import { create } from "zustand";
import { persist } from "zustand/middleware";
import { DEFAULT_MONGO_CONNECTION_NAME } from "../constants";
import { serverGET } from "../HttpFunctions";

const useUserStore = create(
  persist(
    (set: any, get: any) => ({
      user: null,
      isLogged: false,
      selectedWorkSpace: undefined,
      tenantId: DEFAULT_MONGO_CONNECTION_NAME,
      fetchUserLoading: false,
      changeWorkSpace: (workSpaceId, queryClient) => {
        set({ selectedWorkSpace: workSpaceId });
        queryClient.clear();
        window.location.href = "/";
      },

      setUser: (user) =>
        set({
          user,
        }),

      login: (user) =>
        set({
          user,
          isLogged: !!user,
          selectedWorkSpace: user?.workSpace?._id || undefined,
          tenantId: user?.tenantID?.[0]?._id || DEFAULT_MONGO_CONNECTION_NAME,
        }),

      changeTenantID: (tenantID, queryClient) => {
        set({ tenantId: tenantID });
        const { fetchMember } = get();
        fetchMember(queryClient);
      },

      logout: () => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user-storage");
        set({
          user: null,
          isLogged: false,
          selectedWorkSpace: undefined,
          tenantId: DEFAULT_MONGO_CONNECTION_NAME,
          fetchUserLoading: false,
        });
        // window.location.href = "/login";
      },

      fetchMember: async (queryClient) => {
        try {
          set({ fetchUserLoading: true });
          const { user, changeWorkSpace } = get();
          const response = await serverGET(
            "/members/change-tenant/" + user.email
          );
          if (!response) return;
          set({ user: response?.user, fetchUserLoading: false });
          localStorage.setItem(
            "accessToken",
            response?.tokens?.accessToken?.token
          );
          localStorage.setItem(
            "refreshToken",
            response?.tokens?.refreshToken?.token
          );
          if (queryClient) {
            changeWorkSpace(response?.user?.workSpace?._id, queryClient);
          }
        } catch (error) {
          set({ fetchUserLoading: false });
          // set({ error: error.message, isLoading: false });
          console.log(error);
        }
      },

      fetchUser: async (queryClient) => {
        try {
          set({ fetchUserLoading: true });
          const { user, changeWorkSpace } = get();
          const response = await serverGET("/members/" + user._id);
          if (!response) return;
          set({ user: response, fetchUserLoading: false });
          if (queryClient) {
            changeWorkSpace(response.workSpace[0]._id, queryClient);
          }
        } catch (error) {
          set({ fetchUserLoading: false });
          // set({ error: error.message, isLoading: false });
          console.log(error);
        }
      },

      isTokenExpired: (token) => {
        if (!token) return true;
        const jwtPayload = JSON.parse(atob(token.split(".")[1]));
        const exp = jwtPayload.exp;
        const now = Math.floor(Date.now() / 1000);

        return exp < now;
      },
    }),
    {
      name: "user-storage",
      getStorage: () => localStorage,
    }
  )
);

export default useUserStore;
